var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4871_901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.375C0 4.19922 4.22321 0 9.42857 0H18.8571V18.623C18.8571 19.9316 20.3795 20.6641 21.4107 19.8437L26.7143 15.625L32.0179 19.8437C33.0491 20.6641 34.5714 19.9316 34.5714 18.623V0H37.7143H40.8571C42.5955 0 44 1.39648 44 3.125V34.375C44 36.1035 42.5955 37.5 40.8571 37.5V43.75C42.5955 43.75 44 45.1465 44 46.875C44 48.6035 42.5955 50 40.8571 50H37.7143H9.42857C4.22321 50 0 45.8008 0 40.625V9.375ZM6.28571 40.625C6.28571 42.3535 7.69018 43.75 9.42857 43.75H34.5714V37.5H9.42857C7.69018 37.5 6.28571 38.8965 6.28571 40.625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4871_901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite1);
export default __webpack_public_path__ + "static/media/favorite1.f6a84c62af644fffc7d03f187c1f61f3.svg";
export { ForwardRef as ReactComponent };